const passengerCount = value => {
  if (value === null || value === undefined || value === '') return null
  const count = Number(value)
  return Number.isInteger(count) && count >= 0 ? count : null
}

export const leadFlightSearch = (lead, today) => {
  const children = passengerCount(lead.children)
  const adults = passengerCount(lead.adults)
  const teenagers = passengerCount(lead.teenagers)
  const pax = passengerCount(lead.pax)
  const search = { children: children === null ? 0 : children, infants: 0 }

  if (adults !== null) {
    search.adults = adults + (teenagers || 0)
  } else if (pax !== null) {
    search.adults = Math.max(0, pax - search.children)
  }

  // Travel/tour dates are suggestions, not a confirmed domestic flight date.
  const dates = [lead.client_group?.transport?.arrival, lead.client_group?.tour_dates?.first_activity]
  const departure = dates.find(date => typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date) && date > today)
  if (departure) search.departure = departure

  return search
}
